var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddAllSizes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.779,
    height: 14.779,
    viewBox: "0 0 14.779 14.779",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Add_All_Sizes",
    "data-name": "Add All Sizes",
    d: "M83.261-867.138v-8.142a1.378,1.378,0,0,1,.443-1.034,1.469,1.469,0,0,1,1.052-.425h8.105a1.422,1.422,0,0,1,1.043.434,1.422,1.422,0,0,1,.434,1.043v5.908l-3.693,3.693H84.738a1.423,1.423,0,0,1-1.043-.434A1.422,1.422,0,0,1,83.261-867.138Zm-3.674-10.155a1.386,1.386,0,0,1,.24-1.1,1.456,1.456,0,0,1,.96-.6l8.013-1.422a1.386,1.386,0,0,1,1.1.24,1.457,1.457,0,0,1,.6.96l.185,1H89.169l-.129-.739-7.995,1.422.739,4.173v5.151a1.66,1.66,0,0,1-.508-.443,1.365,1.365,0,0,1-.268-.628Zm5.151,2.031v8.124h5.17l2.954-2.954v-5.17ZM88.8-871.2Zm-.739,2.954h1.477v-2.216h2.216v-1.477H89.538v-2.216H88.061v2.216H85.846v1.477h2.216Z",
    transform: "translate(-79.56 880.44)",
    fill: "#2a1fb3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddAllSizes);
export default __webpack_public_path__ + "static/media/add_all_sizes.f0c2eda144a22d225e27534387a84e37.svg";
export { ForwardRef as ReactComponent };